module.exports = __webpack_public_path__ + "static/media/profile-removebg-preview.1483d47b.png";